import { useState } from "react";
import { doseForLb, daysForLb } from "@/data/catalog";
import { useCart } from "@/context/CartContext";
import { useLang } from "@/i18n/LanguageContext";

const FR_DOSE = { 0.25: "Un quart de mesure", 0.5: "Une demi-mesure", 0.75: "Trois quarts de mesure", 1: "Une mesure complète" };
const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);

export const measureSentence = (lb, t, jarMeasures = 60) => {
  const band = doseForLb(lb);
  if (!jarMeasures) return t(`${cap(band.label)} a day.`, `${FR_DOSE[band.dose]} par jour.`);
  const days = Math.floor(jarMeasures / band.dose);
  return t(`${cap(band.label)} a day. This jar lasts your dog ${days} days.`, `${FR_DOSE[band.dose]} par jour. Ce pot dure ${days} jours pour votre chien.`);
};

/* Weight in, daily measure and days-per-jar out. Shares the weight with the cart and sticky bar. */
export const MeasureCalc = ({ jarMeasures = 60, testid = "measure-calc" }) => {
  const { weightLb, setWeightLb } = useCart();
  const { t } = useLang();
  const [unit, setUnit] = useState("lb");
  const [raw, setRaw] = useState(weightLb ? String(weightLb) : "");
  const onChange = (v, u = unit) => {
    setRaw(v);
    const n = parseFloat(v);
    setWeightLb(n > 0 ? (u === "kg" ? n * 2.20462 : n) : 0);
  };
  return (
    <div data-testid={testid} className="mcalc" data-no-translate>
      <div className="in">
        <input id={`${testid}-input`} data-testid={`${testid}-input`} inputMode="decimal" value={raw} placeholder="45"
          aria-label={t("Your dog's weight", "Le poids de votre chien")}
          onChange={(e) => onChange(e.target.value.replace(/[^0-9.]/g, ""))} />
        {["lb", "kg"].map((u) => (
          <button key={u} type="button" className="u" data-testid={`${testid}-unit-${u}`} aria-pressed={unit === u} onClick={() => { setUnit(u); onChange(raw, u); }}>
            {u.toUpperCase()}
          </button>
        ))}
      </div>
      <p data-testid={`${testid}-result`} className="out">
        {measureSentence(weightLb > 0 ? weightLb : (unit === "kg" ? 45 * 2.20462 : 45), t, jarMeasures)}
      </p>
    </div>
  );
};

export const daysLabel = (lb, t) => (lb > 0 ? t(`lasts your ${lb} lb dog ${daysForLb(lb)} days`, `dure ${daysForLb(lb)} jours pour votre chien de ${lb} lb`) : "");
